// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-7Zu","title":"styles_title__GGW_j"};